export default "__VITE_ASSET__CCyz8vYZ__"